export const ipfsUriToHttps = (uri) => uri.replace('ipfs://', 'https://ipfs.io/ipfs/');